import {
	GET_PAYTIMECODES, GET_PAYTIMECODES_SUCCESS, GET_PAYTIMECODES_FAIL,
	GET_PAYTIMECODES_DETAILS, GET_PAYTIMECODES_DETAILS_SUCCESS, GET_PAYTIMECODES_DETAILS_FAIL,
	PAYTIMECODE_CREATE, PAYTIMECODE_CREATE_FAIL, PAYTIMECODE_CREATE_SUCCESS,
	PAYTIMECODE_DELETE, PAYTIMECODE_DELETE_FAIL, PAYTIMECODE_DELETE_SUCCESS,
	PAYTIMECODE_UPDATE, PAYTIMECODE_UPDATE_FAIL, PAYTIMECODE_UPDATE_SUCCESS,RESET,
} from "./actionTypes";

const initialState = {
	paytimecodeList: [],
	paytimecode: {},
	postingResult: {},
	loading: false,
	loadingPaytimecodeDetails: false,
	paytimecodeSetting:{},
	loadingpaytimecodeSetting: false,
	// loading: false,
	error: {
		message: "",
	},
};

const PaytimecodeReducer = (state = initialState, action) => {
	if (!action)
		return state;
	switch (action.type) {
		case GET_PAYTIMECODES:
			state = { ...state, loading: false };
			break;
		case GET_PAYTIMECODES_SUCCESS:
			state = { ...state, paytimecodeList: action.payload, loading: false };
			break;
		case GET_PAYTIMECODES_FAIL:
			state = {
				...state,
				error: {
					message: "Error",
				},
				loading: false,
			};
			break;
		case GET_PAYTIMECODES_DETAILS:
			state = { ...state, loadingPaytimecodeDetails: true };
			break;
		case GET_PAYTIMECODES_DETAILS_SUCCESS:
			state = { ...state, paytimecode: action.payload, loadingPaytimecodeDetails: false };
			break;
		case GET_PAYTIMECODES_DETAILS_FAIL:
			state = {
				...state,
				error: {
					message: "Error",
				},
				loadingPaytimecodeDetails: false,
			};
			break;
		case PAYTIMECODE_CREATE:
			state = { ...state, postingResult: {}, loading: true };
			console.log(state.postingResult);
			break;
		case PAYTIMECODE_CREATE_SUCCESS:
			console.log(action);
			state = { ...state, postingResult: action.payload, loading: false };
			console.log(state.postingResult);
			break;
		case PAYTIMECODE_CREATE_FAIL:
			state = {
				...state,
				error: {
					message: "Error",
				},
				postingResult: {},
				loading: false,
			};
			break;
		case PAYTIMECODE_UPDATE:
			state = { ...state, postingResult: {}, loading: true };
			break;
		case PAYTIMECODE_UPDATE_SUCCESS:
			state = { ...state, postingResult: action.payload, loading: false };
			break;
		case PAYTIMECODE_UPDATE_FAIL:
			state = {
				...state,
				error: {
					message: "Error",
				},
				loading: false,
			};
			break;
		case PAYTIMECODE_DELETE:
			state = { ...state, postingResult: {}, loading: true };
			break;
		case PAYTIMECODE_DELETE_SUCCESS:
			state = { ...state, postingResult: action.payload, loading: false };
			break;
		case PAYTIMECODE_DELETE_FAIL:
			state = {
				...state,
				error: {
					message: "Error",
				},
				loading: false,
			};
			break;
			case RESET:
		state = { ...state, paytimecode: {} }
			
		default:
			state = { ...state };
			break;
	}
	return state;
};

export default PaytimecodeReducer;